console.log("AwayJS - Parsers - 0.8.3");
export { AWDParser } from "./lib/AWDParser";
export { FontParser } from "./lib/FontParser";
export { Max3DSParser } from "./lib/Max3DSParser";
export { FNTParser } from "./lib/FNTParser";
export { MD2Parser } from "./lib/MD2Parser";
export { MD5AnimParser } from "./lib/MD5AnimParser";
export { MD5MeshParser } from "./lib/MD5MeshParser";
export { OBJParser } from "./lib/OBJParser";
export { Parsers } from "./lib/Parsers";
